import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { FiEdit2, FiTrash2, FiEye } from 'react-icons/fi'
import { MdOutlineClose } from 'react-icons/md'
import { RiAlertFill } from 'react-icons/ri'
import columns from '../columns'
import Select from 'react-select'
import CustomModal from '../../../components/common/CustomModal'
import { getRole } from '../../../utils/cookies/cookies'


const BigTaskList = () => {
    const [data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isDeleteLoading, setIsDeleteLoading] = useState(false)
    const [selectedTask, setSelectedTask] = useState(null)
    const [pages, setPages] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalRows, setTotalRows] = useState(0)
    const [companyOptions, setCompanyOptions] = useState([])
    const [selectedCompany, setSelectedCompany] = useState('')
    const [statusOptions, setStatusOptions] = useState([])
    const [selectedStatus, setSelectedStatus] = useState('')

    const role = getRole()
    const location = useLocation();

    const fetchData = async () => {
        try {
            const params = {
                page: pages,
                limit,
                company: selectedCompany,
                bigButton: true, // ✅ FIXED BIG TASK FILTER
            }

            if (selectedStatus) params.status = selectedStatus

            const response = await axiosAuthInstance.get('task/list', params)

            if (response && response.status === 200) {
                const transformedData = response.data.result.docs.map((item) => ({
                    ...item,
                    actions: (
                        <div className='flex items-center'>

                            <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                                <Link to={`view/${item._id}`}>
                                    <FiEye className='w-4 h-4' />
                                </Link>
                            </div>

                            {(role === 'admin' || role === 'HR') && (
                                <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                                    <Link to={`edit/${item._id}`} state={{ from: location.pathname }}>
                                        <FiEdit2 className='w-4 h-4' />
                                    </Link>
                                </div>
                            )}

                            {(role === 'admin' || role === 'HR') && (
                                <div
                                    className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                                    onClick={() => handleOpenDeleteModal(item._id)}
                                >
                                    <FiTrash2 className='w-4 h-4' />
                                </div>
                            )}
                        </div>
                    ),
                }))

                setData(transformedData)
                setTotalRows(response.data.result.totalDocs)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const fetchCompanyData = async () => {
        try {
            const response = await axiosAuthInstance.get('company/dropdown')
            if (response.status === 200) {
                setCompanyOptions(
                    response.data.result.map((item) => ({
                        value: item._id,
                        label: item.name,
                    }))
                )
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchStatusOptions = async () => {
        try {
            const res = await axiosAuthInstance.get('task-status/dropdown')
            if (res.status === 200) {
                setStatusOptions(
                    res.data.result.map((status) => ({
                        value: status._id,
                        label: status.name,
                    }))
                )
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchData()
    }, [pages, limit, selectedCompany, selectedStatus])

    useEffect(() => {
        fetchCompanyData()
        fetchStatusOptions()
    }, [])

    const handleOpenDeleteModal = (id) => {
        setSelectedTask(id)
        setIsModalOpen(true)
    }
    const handleCloseModal = () => {
        setIsModalOpen(false)
        setSelectedTask(null)
    }
    const handleDelete = async () => {
        setIsDeleteLoading(true)
        try {
            const response = await axiosAuthInstance.delete(`task/delete/${selectedTask}`)
            if (response.status === 200) {
                fetchData()
                setIsDeleteLoading(false)
                setIsModalOpen(false)
            }
        } catch (error) {
            setIsDeleteLoading(false)
            setIsModalOpen(false)
        }
    }

    return (
        <div>
            <div className='flex items-center justify-between border-b px-4 pb-2'>
                <h1 className='text-2xl font-semibold'>Big Tasks</h1>

                <div className='flex gap-4'>
                    <Select
                        options={statusOptions}
                        onChange={(opt) => setSelectedStatus(opt ? opt.value : '')}
                        isClearable
                        placeholder='Filter by Status'
                    />

                    <Select
                        value={companyOptions.find((opt) => opt.value === selectedCompany)}
                        onChange={(opt) => setSelectedCompany(opt ? opt.value : '')}
                        options={companyOptions}
                        isClearable
                        placeholder='Select Company'
                    />
                </div>
            </div>

            <DataTable
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={limit}
                onChangePage={(p) => setPages(p)}
                onChangeRowsPerPage={(l) => setLimit(l)}
            />

            {isModalOpen && (
                <CustomModal handleCloseModal={handleCloseModal}>
                    <div className='p-4 relative'>
                        <div
                            className='absolute right-5 cursor-pointer hover:opacity-70'
                            onClick={handleCloseModal}
                        >
                            <MdOutlineClose className='text-2xl' />
                        </div>
                        <div className='flex flex-col items-center justify-between gap-4'>
                            <div className='flex flex-wrap justify-center alert-ico'>
                                <RiAlertFill className='text-5xl' />
                            </div>
                            <h2>Are you sure you want to delete this Task?</h2>
                            <div className='flex gap-4 mt-4'>
                                <button
                                    onClick={handleCloseModal}
                                    className='bg-gray-300 px-4 py-2 rounded'
                                >
                                    No, Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    className='bg-red-500 text-white px-4 py-2 rounded'
                                >
                                    {isDeleteLoading ? (
                                        <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent' />
                                    ) : (
                                        "Yes, I'm sure"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            )}
        </div>
    )
}

export default BigTaskList
